// extracted by mini-css-extract-plugin
module.exports = {"component":"CarModel_component__YJ7Q6"};